import { SearchType } from '@brightdrop/bd-ui';
import { DrawingMode } from '@brightdrop/map-ui/models/drawing';
import type { SearchCriteria } from '~/common/models/common.model';
import type {
  GeofenceDrawingState,
  GeofenceListItem,
} from '~/common/models/geofences.model';

export const GEOFENCE_SEARCH_CRITERIA_DEFAULT_STATE: SearchCriteria = {
  searchType: SearchType.GEOFENCES_SEARCH,
  input: '',
};

// Session view types for geofence state
export enum GeofenceSessionViewType {
  LIST = 'Geofence List',
}

// Geofence pagination and rendering batch size
// This controls both API page size and progressive rendering batch size
export const GEOFENCE_PAGE_SIZE = 50;

// Default circle radius in kilometers (used when no shape data exists)
export const DEFAULT_CIRCLE_RADIUS_KM = 0.5;

// Session-scoped list state
export type GeofenceListSessionState = {
  accumulatedGeofences: GeofenceListItem[];
  totalCount: number | null;
  requestParamsHash: string | null;
  searchCriteria: SearchCriteria;
};

// Session configurations by view type and session ID
export type GeofenceSessionConfigs = {
  [GeofenceSessionViewType.LIST]?: {
    [sessionId: string]: GeofenceListSessionState;
  };
};

// Root geofence state
export type GeofenceState = {
  drawing: GeofenceDrawingState;
  selectedGeofence: GeofenceListItem | null;
  hoveredGeofence: GeofenceListItem | null;
  sessionConfigs: GeofenceSessionConfigs;
  // Rule dialog state - tracks which rule is being edited/deleted across components
  editableRuleId: string | null;
  deletingRuleId: string | null;
};

export const INITIAL_GEOFENCE_DRAWING_STATE: GeofenceDrawingState = {
  drawingMode: DrawingMode.OFF,
  selectedShapeType: null,
  currentShapeData: null,
  isDrawingEnabled: false,
  targetShapeCenter: null,
};

export const INITIAL_GEOFENCE_LIST_SESSION_STATE: GeofenceListSessionState = {
  accumulatedGeofences: [],
  totalCount: null,
  requestParamsHash: null,
  searchCriteria: GEOFENCE_SEARCH_CRITERIA_DEFAULT_STATE,
};

export const INITIAL_GEOFENCE_STATE: GeofenceState = {
  drawing: INITIAL_GEOFENCE_DRAWING_STATE,
  selectedGeofence: null,
  hoveredGeofence: null,
  sessionConfigs: {},
  editableRuleId: null,
  deletingRuleId: null,
};
